import type { RouteLocationNormalized } from 'vue-router';
import { g6Permission } from 'glasssix-utils-ts';
import Router from './index';

Router.beforeEach(async (to: RouteLocationNormalized) => g6Permission.routerBeforeEachFn(to, localStorage.getItem('token') ?? ''));
